import styled from 'styled-components';
import { LineBordered as BorderedLine } from 'app/components';
import { textTransform } from 'utils';

export const LineBordered = styled(BorderedLine)`
  // font-size: 1.8rem;
  font-size:${({ fontSize }) => fontSize?.subListLink};
  line-height: 1.33;
  border-top: 0;

  h3 {
    font-weight: 390;
    font-size: 18px;
    line-height: 24px;

    &.invalid {
      color: #F39696;
    }
  }
`;

export const Seats = styled(BorderedLine)`
  justify-content: start;
`;
export const SeatsAfterSelections = styled.div`
@media screen and (max-width: 999px) {
  display:none;
}
`;

export const SeatsItem = styled.span`
  margin-right: ${({ theme }) => theme.indent.m};
  // font-size: 1.6rem;
  font-size:${({ fontSize }) => fontSize?.headerNavbar};
  font-weight: 500;
  line-height: 1.5;
  text-transform: ${textTransform};
`;

export const Total = styled.span`
  text-transform: ${textTransform};
  font-weight: 700;
  // font-size: 1.6rem;
  font-size:${({ fontSize }) => fontSize?.headerNavbar};

  .svg-cart {
    vertical-align: middle;
    width: 24px;
    height: 24px;
    margin-right: ${({ theme }) => theme.indent.s};
  }

  & > span {
    vertical-align: middle;
  }
  `;

export const Ticket = styled.span`
  text-transform: ${textTransform};
  font-weight: 700;
  font-size:${({ fontSize }) => fontSize?.headerNavbar};

  .svg-cart {
    vertical-align: middle;
    width: 24px;
    height: 24px;
    margin-right: ${({ theme }) => theme.indent.s};
  }

  & > span {
    vertical-align: middle;
  }
`;

